module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("mobileAppInstructionsView.title")))]), _vm._v(" "), _vm._l((_vm.store.globalSettings.mobileInstructions ? _vm.store.globalSettings.mobileInstructions.split('\n') : ''), function(paragraph, i) {
    return _c('p', {
      key: i,
      staticClass: "about"
    }, [_vm._v("\r\n        " + _vm._s(paragraph) + "\r\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ff38e232","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/MobileAppInstructionsView.vue
// module id = 132
// module chunks = 0